// The reserved "master" agency that owns super-admin-authored categories, job
// roles and sectors — same dev/prod id pair used by the super-admin app's
// SUPER_ADMIN_OWNER_AGENCY_ID (super-admin/src/layouts/superadmin/AgentBuilder/context/usersContext.js).
export const SUPER_ADMIN_OWNER_AGENCY_ID =
  window.location.hostname.includes('maybedev') || window.location.hostname.includes('localhost')
    ? '68f22c8ddcb06046ab258bc2'
    : '6739f1be347a7f5974735cec';
